import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromAccountActions from '././../actions/account.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal.service';
import { AppState } from '../app.state';

@Injectable()
export class AccountEffects {

  userProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/admin/home/dashboard');
      }),
      exhaustMap((action) =>
        this.accountService.userProfile().pipe(
          map((response) => { 
            console.log('userProfile$', response);
            return fromAccountActions.getUserProfileSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(failedTransaction({ data: response.error }));
          })
        )
      )
    )
  });

  getScorers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/admin/home/scorer');
      }),
      exhaustMap((action) =>
        this.accountService.getScorers().pipe(
          map((response) => { 
            console.log('getScorers$', response);
            return fromAccountActions.getScorersSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(failedTransaction({ data: response.error }));
          })
        )
      )
    )
  });

  reloadScorers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAccountActions.getScorers),
      mergeMap(() => {
        return this.accountService.getScorers().pipe(
          map((response: APIResponse) => {           
            console.log('reloadScorers$', response);
            return fromAccountActions.getScorersSuccess({ data: response?.details});
          })
        );
      })
    )
  );

  createScorer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAccountActions.createScorers),
      exhaustMap((action) =>
        this.accountService.createScorer(action.data).pipe(
          map((response) => {
            const data = {
              season: action?.data?.season
            }
            return fromAccountActions.createScorersSuccess({ data });
          }),
          catchError((response) => {
            console.error('createPlayers$', response);
            return of(fromAccountActions.createScorersFailed({ data: response }));
          })
        )
      )
    )
  );

  createScorersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccountActions.createScorersSuccess),
        tap(async (action) => {
          this.modalService.hideReviewDetails();
          this.modalService.hideCreateScorer();
          this.store.dispatch(fromAccountActions.getScorers());
          console.log('createScorersSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createScorersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccountActions.createScorersFailed),
        tap(async (action) => {
          console.log('createScorersFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getPlayers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/admin/home/players');
      }),
      exhaustMap(() =>
        this.accountService.getPlayers().pipe(
          map((response) => { 
            console.log('getPlayers$', response);
            return fromAccountActions.getPlayersSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(failedTransaction({ data: response.error }));
          })
        )
      )
    )
  });

  reloadPlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAccountActions.getPlayers),
      mergeMap(() => {
        return this.accountService.getPlayers().pipe(
          map((response: APIResponse) => {           
            console.log('reloadPlayers$', response);
            return fromAccountActions.getPlayersSuccess({ data: response?.details});
          })
        );
      })
    )
  );

  createPlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAccountActions.createPlayers),
      exhaustMap((action) =>
        this.accountService.createPlayer(action.data).pipe(
          map((response) => {
            const data = {
              season: action?.data?.season
            }
            return fromAccountActions.createPlayersSuccess({ data });
          }),
          catchError((response) => {
            console.error('createPlayers$', response);
            return of(fromAccountActions.createPlayersFailed({ data: response }));
          })
        )
      )
    )
  );

  createPlayersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccountActions.createPlayersSuccess),
        tap(async (action) => {
          this.modalService.hideReviewDetails();
          this.modalService.hideCreatePlayer();
          this.store.dispatch(fromAccountActions.getPlayers());
          console.log('createPlayersSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createPlayersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAccountActions.createPlayersFailed),
        tap(async (action) => {
          console.log('createPlayersFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  failedTransaction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(failedTransaction),
        tap((action) => {
          if(action?.data?.message == 'Unauthenticated.'){
            this.router.navigateByUrl('/landing');
          }
          console.log('failedTransaction$', action.data);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private router: Router,
    private modalService: ModalService,
    private store: Store<AppState>
    // private store: Store<AppState>,
  ) {}

}
